import { Fragment } from "react/jsx-runtime";
import ReportsSectionContent from "./qapi_section";
import {
  ReportContainer,
  Section,
  SectionLight,
  SectionDark,
  SectionHeading,
  HeaderText,
  LineKey,
  LineVal,
  LineTextInd,
  ReportDetail,
  SubSection,
  SectionFooter,
  FooterDisclaimer,
  FooterDate,
  PrintRepeatFooter,
  PrintFooterDate,
  PrintFooterPageNumber,
} from "./qapi_template.styles";
import moment from "moment";

const QapiBody = ({ incidentData, transformedIncident, isNonQapi, includeStatements }: any) => {
  return (
    <ReportContainer>
      <SectionLight>
        {transformedIncident.map((item: any, itemIndex: number) => {
          const [heading, subHeadings] = Object.entries(item)[0] as [string, any];
          const isSectionEmpty =
            Object.values(subHeadings as any).flat().length === 0;
          const shouldRenderHeader = isNonQapi ? !isSectionEmpty : true;
          return (
            <ReportDetail key={`${heading}-${itemIndex}`}>
              {shouldRenderHeader && heading === 'Injuries' && subHeadings.Default?.[0]?.fieldValue !== 'No records reported' && Array.isArray(subHeadings.Default?.[0]?.fieldValue) && (
                <>
                  <SectionHeading>{heading}</SectionHeading>
                  {subHeadings.Default[0].fieldValue.map((injury: any, injuryIndex: number) => {
                    return (<SubSection key={`injury-${injuryIndex}`}>
                      <LineTextInd><LineKey>Type: </LineKey><LineVal>{injury.Type}</LineVal><LineKey>Location: </LineKey><LineVal>{injury.Location}</LineVal></LineTextInd>
                      <LineTextInd><LineKey>Date/Time Injury reported: </LineKey><LineVal>{injury['Date/Time Injury reported']}</LineVal></LineTextInd>
                      <LineTextInd><LineKey>Description: </LineKey><LineVal>{injury.Description}</LineVal></LineTextInd>
                    </SubSection>
                    )
                  })}
                </>
              )}
              {shouldRenderHeader && heading !== 'Injuries' && heading !== 'Statements' && (
                <SectionHeading>{heading}</SectionHeading>
              )}
              {shouldRenderHeader && heading === 'Statements' && (!isNonQapi || includeStatements) && (
                <>
                  <SectionHeading>{heading}</SectionHeading>
                  {/* Regular statement fields (supervisor notified, etc.) */}
                  {subHeadings.Statements && subHeadings.Statements.length > 0 && (
                    subHeadings.Statements.map((field: any, fieldIdx: number) => (
                      <LineTextInd key={`stmt-field-${fieldIdx}`}>
                        <LineKey>{field.fieldLabel}</LineKey>
                        <LineVal>{field.fieldValue}</LineVal>
                      </LineTextInd>
                    ))
                  )}
                  {/* Interview records */}
                  {subHeadings.Interviews?.[0]?.fieldValue !== 'No records reported' &&
                    Array.isArray(subHeadings.Interviews?.[0]?.fieldValue) && (
                    <>
                      <HeaderText>Interviews</HeaderText>
                      {subHeadings.Interviews[0].fieldValue.map((interview: any, intIdx: number) => (
                        <SubSection key={`interview-${intIdx}`}>
                          <LineTextInd><LineKey>Interviewer Name: </LineKey><LineVal>{interview['Interviewer Name'] || '-'}</LineVal></LineTextInd>
                          <LineTextInd><LineKey>Interviewee Name: </LineKey><LineVal>{interview['Interviewee Name'] || '-'}</LineVal></LineTextInd>
                          <LineTextInd><LineKey>Date/Time of Interview: </LineKey><LineVal>{interview['Date/Time of Interview'] || '-'}</LineVal></LineTextInd>
                          <LineTextInd><LineKey>Interviewee Statement: </LineKey><LineVal>{interview['Interviewee Statement'] || '-'}</LineVal></LineTextInd>
                        </SubSection>
                      ))}
                    </>
                  )}
                </>
              )}
              {heading !== 'Injuries' && heading !== 'Statements' && (
                <ReportsSectionContent
                  heading={heading}
                  subHeadings={subHeadings as any}
                  isSectionEmpty={isSectionEmpty}
                  shouldHeaderRender={shouldRenderHeader}
                />
              )}
            </ReportDetail>
          );
        })}
      </SectionLight>
      {/* Screen-only footer (hidden in print, replaced by PrintRepeatFooter) */}
      <SectionFooter>
        <FooterDisclaimer>
          The information contained and set-forth herein, including but not limited to the collection, analysis and storage of such information, is protected by the non-disclosure and confidentiality provisions afforded pursuant to the Federal quality assurance privilege as codified in 42 U.S.C.A. 1396(r)(b)(1)(B), The Patient Safety &amp; Quality Improvement Act of 2005 (42 U.S.C. §299 et. seq.) and all applicable privileges afforded from dissemination and disclosure pursuant to and codified in State Law
        </FooterDisclaimer>
        <FooterDate>
          {moment().format("MMMM Do, YYYY")}
        </FooterDate>
      </SectionFooter>
      {/* Print-only footer — position:fixed makes it repeat on every page */}
      <PrintRepeatFooter>
        The information contained and set-forth herein is protected by the Federal quality assurance privilege as codified in 42 U.S.C.A. 1396(r)(b)(1)(B) and The Patient Safety &amp; Quality Improvement Act of 2005 (42 U.S.C. §299 et. seq.) and all applicable State Law privileges.
        <PrintFooterDate>{moment().format("MMMM Do, YYYY")}</PrintFooterDate>
      </PrintRepeatFooter>
    </ReportContainer>
  );
};
export default QapiBody;